export default "__VITE_ASSET__DdAZV2wZ__"